import { Component } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { LanguageService } from '../../../core/services/language.service';
import { LoadingComponent } from "../loading/loading.component";
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sidebar-bottom-section',
  imports: [TranslateModule,CommonModule ],
  templateUrl: './sidebar-bottom-section.component.html',
  styleUrl: './sidebar-bottom-section.component.scss',
})
export class SidebarBottomSectionComponent {
  isRtl: boolean = false;
   private sub!: Subscription;
   
  constructor(
    private authService: AuthService,
    public languageService: LanguageService
  ) {
        this.sub = this.languageService.rtl$.subscribe((rtl) => {
      this.isRtl = rtl;
    });
  }

 
  logout() {
    this.authService.logout();
  }
    ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
